
import { Injectable } from "@angular/core";


@Injectable({
    providedIn: "root",
})
export class TokenService {
  
    constructor() {
    }


    getAccessToken() {
        return localStorage.getItem('token');
    }

    setAccessToken(accessToken) {
        localStorage.removeItem('token');          
        localStorage.setItem('token',accessToken);
    }

    setPermissions(permission) {
        localStorage.removeItem('permission');          
        localStorage.setItem('permission',permission);
    }

    setUser(user) {
        localStorage.removeItem('user');          
        localStorage.setItem('user',user);
    }

    getPermissions() {
        return localStorage.getItem('permission');
    }
    
    setRoles(roles) {
        localStorage.removeItem('roles');          
        localStorage.setItem('roles',roles);
    }

    getRoles() {
        return localStorage.getItem('roles');
    }

    getUser() {
        return localStorage.getItem('user');
    }

    setBranch(roles) {
        localStorage.removeItem('branch');          
        localStorage.setItem('branch',roles);
    }

    getBranch() {
        return localStorage.getItem('branch');
    }

}
